import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./PartnerApplicationPage.css";

const PARTNER_FORM_URL =
  "https://frontal-firestorm-840.forms.space/partner-with-office-outing-naiz6q";

const PartnerApplicationPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });

    const existingScript = document.querySelector(
      "script[data-formspace-partner-embed]"
    );

    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement("script");

    script.src = "https://formspace.com/embed.js";
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.dataset.formspacePartnerEmbed = "true";

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <main className="partner-application-page">
      {/* HERO */}
      <section className="partner-application-hero">
        <div className="partner-application-hero-inner">
          <Link
            to="/partners"
            className="partner-application-back"
          >
            <span aria-hidden="true">←</span>
            Back to For Partners
          </Link>

          <p className="partner-application-eyebrow">
            TEAMWARD PARTNERS
          </p>

          <h1>Bring your experience to more teams.</h1>

          <p className="partner-application-description">
            Join Teamward to get your business in front of
            companies looking for memorable outings, trainings,
            speakers, retreats, and volunteer experiences.
          </p>

          <div className="partner-benefits">
            <div className="partner-benefit">
              <span
                className="partner-benefit-icon"
                aria-hidden="true"
              >
                ✓
              </span>

              <span>Free to apply</span>
            </div>

            <div className="partner-benefit">
              <span
                className="partner-benefit-icon"
                aria-hidden="true"
              >
                ✓
              </span>

              <span>No upfront listing fee</span>
            </div>

            <div className="partner-benefit">
              <span
                className="partner-benefit-icon"
                aria-hidden="true"
              >
                ✓
              </span>

              <span>Nonexclusive</span>
            </div>
          </div>

          <p className="partner-commission-disclosure">
            Some partnerships may include a referral commission
            on completed, attributed bookings. All terms are
            agreed upon in advance.
          </p>
        </div>
      </section>

      {/* APPLICATION */}
      <section className="partner-application-content">
        <div className="partner-application-content-inner">
          <div className="partner-application-heading">
            <p className="partner-form-eyebrow">
              PARTNER APPLICATION
            </p>

            <h2>Tell us about your business.</h2>

            <p>
              Share what you offer, who you serve, your group
              capacity, pricing, and partnership preferences.
              We’ll review your information and follow up with
              next steps.
            </p>
          </div>

          <section className="partner-application-form-card">
            <div
              className="partner-application-form-embed"
              data-formspace={PARTNER_FORM_URL}
            />
          </section>

          <p className="partner-application-footer-note">
            There is no cost to submit an application.
          </p>
        </div>
      </section>
    </main>
  );
};

export default PartnerApplicationPage;
